module.exports = __webpack_public_path__ + "static/img/licai.b369b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/licai.png
// module id = IwQy
// module chunks = 1